import React from 'react'
import type { FeatureBlock as FeatureBlockProps } from '@/payload-types'
import { CMSLink } from '@/components'
import Image from 'next/image'
import { isMedia } from '@/lib/utils'

export function FeatureBlock({
  title,
  lead,
  overline,
  image,
  links,
}: Readonly<FeatureBlockProps>): React.ReactNode {
  return (
    <section className="group p-8">
      <div className="flex flex-col lg:flex-row lg:group-odd:flex-row-reverse max-w-7xl mx-auto gap-8 border rounded-xl">
        {image && isMedia(image) && image.url ? (
          <figure className="lg:flex-1 m-2 rounded-lg overflow-hidden">
            <Image
              src={image.url}
              alt={image.alt ?? title}
              width={image.width ?? 0}
              height={image.height ?? 0}
            />
          </figure>
        ) : null}
        <div className="lg:flex-1 flex flex-col gap-4 self-center p-8">
          {overline ? <span className="text-xs uppercase">{overline}</span> : null}
          <h2 className="text-lg lg:text-xl font-semibold">{title}</h2>
          <p>{lead}</p>
          {links ? (
            <ul>
              {links.map((item) => {
                return (
                  <li key={item.id}>
                    <CMSLink className="flex md:inline-flex" {...item.link} />
                  </li>
                )
              })}
            </ul>
          ) : null}
        </div>
      </div>
    </section>
  )
}
